'use client';
import { Box } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CustomImage from '@components/CustomImage';
import DynamicButton from '@components/DynamicButton';
import DynamicHideBlock from '@components/DynamicHideBlock';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';

import cn from './style.module.scss';

export type WorldAldarNavigationData = {
  icon?: string;
  description?: {
    mobile?: string;
    desktop?: string;
  };
  button?: {
    url?: string;
    label?: string;
  };
};
type WorldAldarNavigationProps = {
  data?: WorldAldarNavigationData;
  orientation?: 'vertical' | 'horizontal';
  classNames?: {
    wrapper?: string;
    block?: string;
    content?: string;
    icon?: string;
    data?: string;
    buttonWrapper?: string;
    button?: string;
  };
  imageAlt?: string;
};

export default function WorldAldarNavigation({
  data,
  orientation = 'vertical',
  classNames,
  imageAlt = 'World of Aldar',
}: WorldAldarNavigationProps) {
  if (!data) return null;

  const orientationClass =
    orientation === 'horizontal'
      ? cn.worldAldarVisitBlock__horizontal
      : cn.worldAldarVisitBlock__vertical;

  return (
    <Box className={`${cn.worldAldarVisit} ${classNames?.wrapper ?? ''}`}>
      <Box
        className={`${cn.worldAldarVisitBlock} ${orientationClass} ${classNames?.block ?? ''}`}
      >
        <Box
          className={`${cn.worldAldarVisitContent} ${classNames?.content ?? ''}`}
        >
          <DynamicHideBlock data={data?.icon}>
            <Box className={`${cn.visitContentIcon} ${classNames?.icon ?? ''}`}>
              <CustomImage
                src={data?.icon || ''}
                alt={imageAlt}
                width={1920}
                height={1080}
              />
            </Box>
          </DynamicHideBlock>
          <Box className={`${cn.visitContentData} ${classNames?.data ?? ''}`}>
            <Mobile>
              <ParallaxText
                variant="p"
                animationType="zoomIn"
                animationDuration={900}
              >
                {ReactHtmlParser(data?.description?.mobile ?? '')}
              </ParallaxText>
            </Mobile>
            <Desktop>
              <ParallaxText
                variant="p"
                animationType="zoomIn"
                animationDuration={900}
              >
                {ReactHtmlParser(data?.description?.desktop ?? '')}
              </ParallaxText>
            </Desktop>
          </Box>
        </Box>
        <DynamicHideBlock data={data?.button}>
          <Box
            className={`${cn.worldAldarButton} ${classNames?.buttonWrapper ?? ''}`}
          >
            <DynamicButton
              showLink={true}
              target="_blank"
              className={`${cn.visitContentButton} ${classNames?.button ?? ''}`}
              url={data?.button?.url}
              linkLabel={data?.button?.label}
            />
          </Box>
        </DynamicHideBlock>
      </Box>
    </Box>
  );
}
